module.exports = __webpack_public_path__ + "images/company/rank_medal/assessment_achievement_count_rank/3_486660d429f60b4c1b7e167aa88c111c.png";